<template>
  <div class="d-flex mb-4" :class="{ final }">
    <v-icon :class="iconClass">
      mdi-check
    </v-icon>
    <div class="ml-2">
      <div
        class="item-title ml-1 qtm-body"
        :class="final && approval.entry_type === 'REQ' ? 'pending' : ''"
      >
        {{ approval.title }}
      </div>
      <div>
        <div class="item-subtitle ml-1">
          {{ approval.tag }} {{ approval.actionUser }}
          <span v-if="!approval.pending">
            on {{ dateCreated }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { dateYear } from '~/models/filters'

interface Approval {
  actionUser: string
  date_created: number
  entry_type: string
  pending: boolean
  tag: string
  title: string
}

export interface Props {
  approval: Approval
  final?: boolean
}

const props = defineProps<Props>()

const dateCreated = dateYear(props.approval.date_created)
const iconClass = computed(() => {
  if (props.final && props.approval.entry_type === 'REQ') {
    return 'unchecked check-icon'
  }

  return 'check-icon'
})
</script>

<style>
  .check-icon {
    color: white !important;
    background-color: rgb(var(--v-theme-secondary-lighten-1));
  }
  .unchecked.check-icon {
      color: rgb(var(--v-theme-light-grey)) !important;
      background-color: rgb(var(--v-theme-light-grey));
  }
  .item-subtitle {
    display: inline-block;
    vertical-align: top;
    color: rgb(var(--v-theme-mid-grey));
  }
  .final {
    margin-bottom: 0px !important;
  }
  .final .item-subtitle {
    color: rgb(var(--v-theme-dark-grey));
  }
  .item-title {
    color: rgb(var(--v-theme-secondary-lighten-1));
  }
  .item-title.pending {
    color: rgb(var(--v-theme-secondary));
  }
</style>
